// import Vue from 'vue';
import "@root/scss/custom.scss";
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import router from '@apexl/icarus-core/src/router/index.js'
import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import "bootstrap/dist/js/bootstrap.bundle.js";
// Named export: vue-datepicker 12 has no default export, so the default import
// registered `undefined` as the component.
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import Icarus from "@apexl/icarus-core/src/components/Icarus.vue";
import { defaultConfig as formkitConfig, plugin as formkit } from "@formkit/vue";
import * as echarts from "echarts";
import { registerHermesEchartsTheme } from "@root/services/hermesEchartsTheme";
import { useThemeStore } from "@root/store/useThemeStore";

const app = createApp(Icarus);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router);

// Register the parallel 'hermes' ECharts theme once at boot (never mutates the
// package's 'tc' theme). Charts init with echarts.init(el, 'hermes').
registerHermesEchartsTheme(echarts);

// Apply the persisted light/dark preference to <html data-theme>.
useThemeStore(pinia).init();

app.component('VueDatePicker', VueDatePicker);

app.use(formkit, formkitConfig({
  theme: 'genesis'
}));

const requireComponent = require.context(
    '@apexl/icarus-core/src/components', // The relative path of the components' folder
    true, // Whether to look in sub-folders
    /[A-Z]\w+\.(vue|js)$/ // The regular expression used to match base component filenames
);

const requireCustomComponent = require.context(
    './components', // The relative path of the components' folder
    true, // Whether to look in sub-folders
    /[A-Z]\w+\.(vue|js)$/ // The regular expression used to match base component filenames
);

importComponents(app, requireComponent); //import the core components
importComponents(app, requireCustomComponent); //allow projects to override base components

function importComponents(app, components) {
  components.keys().forEach(fileName => {
    const componentConfig = components(fileName); // Get component config

    // Get PascalCase name of component, Gets the file name regardless of folder depth
    const componentName = upperFirst(camelCase(fileName.split('/').pop().replace(/\.\w+$/, '')));

    // Register component globally
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    app.component(
        componentName,
        componentConfig.default || componentConfig
    )
  });
}

app.mount('#app');
